// extracted by mini-css-extract-plugin
export default {"createBillingAgreementAsDialog":"okOPV","submissionMessage":"eSnx4"};